import { render, staticRenderFns } from "./LinteItem.vue?vue&type=template&id=ed8c6e30&"
import script from "./LinteItem.vue?vue&type=script&lang=js&"
export * from "./LinteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports